import memoize from 'lodash/memoize';
import { rgba } from 'polished';
import { getColorByAlias } from '../index.mjs';
import getColorSetWithRgbaConvert from '../helpers/getColorSet.mjs';
import { hex2RGBA } from '../helpers/hexToRgba.mjs';

var DEFAULT_SYSTEM_COLOR = {
  blue: "#0096FF",
  darkBlue: "#1469BF",
  green: "#60ff00",
  darkGreen: "#01D7AB",
  red: "#FB2942",
  yellow: "#FCBA02",
  marine: "#3431CC"
};
function generateColorTheme() {
  var systemColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SYSTEM_COLOR;
  return {
    blue: systemColor.blue,
    red: systemColor.red,
    red100: rgba(systemColor.red, 0.16),
    yellow: systemColor.yellow,
    green: systemColor.green,
    darkGreen: systemColor.darkGreen,
    darkBlue: systemColor.darkBlue,
    darkBlue100: rgba(systemColor.darkBlue, 0.16),
    marine300: "#3E00FF",
    marine400: "#3431CC",
    marine415: rgba("#3431CC", 0.15)
  };
}
var generateColorV2Theme = memoize(function (colorV2) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  return {
    primary: {
      main: hex2RGBA((_a = colorV2.primary.main) !== null && _a !== void 0 ? _a : ""),
      dark: hex2RGBA((_b = colorV2.primary.dark) !== null && _b !== void 0 ? _b : ""),
      light: hex2RGBA((_c = colorV2.primary.light) !== null && _c !== void 0 ? _c : ""),
      main400: hex2RGBA((_d = colorV2.primary.main400) !== null && _d !== void 0 ? _d : ""),
      light400: hex2RGBA((_e = colorV2.primary.light400) !== null && _e !== void 0 ? _e : "")
    },
    secondary: {
      main: hex2RGBA((_f = colorV2.secondary.main) !== null && _f !== void 0 ? _f : ""),
      dark: hex2RGBA((_g = colorV2.secondary.dark) !== null && _g !== void 0 ? _g : ""),
      light: hex2RGBA((_h = colorV2.secondary.light) !== null && _h !== void 0 ? _h : ""),
      main400: hex2RGBA((_j = colorV2.secondary.main400) !== null && _j !== void 0 ? _j : ""),
      light400: hex2RGBA((_k = colorV2.secondary.light400) !== null && _k !== void 0 ? _k : "")
    },
    accent: getColorByAlias(colorV2, colorV2.accent, colorV2.primary.main),
    colorSetV2: getColorSetWithRgbaConvert(colorV2.colorSetV2),
    primaryFogType: colorV2.primaryFogType,
    secondaryFogType: colorV2.secondaryFogType,
    accentFogType: colorV2.accentFogType
  };
});
var generateColorTheme$1 = memoize(generateColorTheme);

export { DEFAULT_SYSTEM_COLOR, generateColorTheme$1 as default, generateColorV2Theme };
